const data = [
  {
    title: "Who We Serve",
    description: "siAi is the first Agentic Brand Manager built for social commerce-native brands. We support founders, CMOs, and growth teams at mid-market DTC brands in fashion, wellness, beauty, and nutraceuticals. These teams don’t just need content. They need smarter decisions—what to create, when to publish, who to partner with, and how to adapt based on results. siAi handles the execution so they can stay focused on vision and growth",
    subdescription: "",
    pointers: []
  },
  {
    title: "Why We Exist",
    description: "The old DTC playbook no longer works",
    subdescription: "siAi changes that. We give every brand a bespoke agent that operates across the full creative and growth loop, intelligently and independently.",
    pointers: [
      "Manual workflows slow down execution",
      "Agencies aren’t built for always-on, real-time social commerce",
      "Most AI tools only generate content—they can’t run the brand"
    ]
  },
  {
    title: "What We Do",
    description: "siAi builds and runs a custom brand agent for each client. It learns your voice, goals, past performance, and competitive landscape. Then it goes to work",
    subdescription: "Founders stay in control through human-in-the-loop approvals, clear workflows, and built-in brand safety. You lead the vision. siAi handles the rest.",
    pointers: [
      "Producing platform-native content",
      "Managing scheduling, testing, and optimization",
      "Sourcing and activating creators and UGC partnerships",
      "Looping in sales, engagement, and sentiment data to improve performance"
    ]
  },
  {
    title: "Why Now",
    description: "Agentic AI is the next frontier. The best companies in AI are focused on agents that take action, not just create assets. siAi brings this shift to brand management. We serve a massively underserved segment—mid-market brands that need the capabilities of a full creative and growth team, but can’t build it in-house. Meanwhile, social commerce is transforming retail. It’s expected to reach $1.2 trillion globally by 2027, led by creator-driven and social-first brands. Now is the time for a smarter operating system.",
    subdescription: "Founders stay in control through human-in-the-loop approvals, clear workflows, and built-in brand safety. You lead the vision. siAi handles the rest.",
    pointers: []
  },
  {
    title: "The Big Picture",
    description: "siAi is more than a creative tool. It is the foundation for:",
    subdescription: "We’re not another point solution. We’re the system that runs the brand.",
    pointers: [
      "Agentic brand operations",
      "Full-loop growth management",
      "Future expansion into commerce ops, partnerships, pricing, and even product development"
    ]
  },
]

const InvestorFeatures = () => {
  return (
    <div className="relative font-poppins tracking-wide container mx-auto space-y-10 py-10 px-7">
      {data.map((section, index) => (
        <div key={index} className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-500 hover:-translate-y-1">
          <div className="flex items-center mb-6">
            <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-indigo-600 rounded-2xl flex items-center justify-center mr-4">
              <span className="text-white font-bold text-lg">{index + 1}</span>
            </div>
            <h2 className="text-3xl font-bold text-gray-900">
              {section.title}
            </h2>
          </div>

          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            {section.description}
          </p>

          {section.pointers.length > 0 && (
            <div className="mb-8">
              <div className="grid gap-4">
                {section.pointers.map((pointer, pointIndex) => (
                  <div key={pointIndex} className="group relative bg-gradient-to-r from-purple-50 to-indigo-50 hover:from-purple-100 hover:to-indigo-100 rounded-xl p-5 border border-purple-100 hover:border-purple-200 transition-all duration-300 hover:shadow-md cursor-pointer">
                    <div className="flex items-center">
                      <div className="w-8 h-8 bg-gradient-to-r from-purple-500 to-indigo-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <span className="text-gray-700 font-medium leading-relaxed group-hover:text-gray-900 transition-colors duration-300">
                        {pointer}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {section.subdescription && (
            <p className="text-gray-600 leading-relaxed italic border-l-4 border-purple-200 pl-4">
              {section.subdescription}
            </p>
          )}
        </div>
      ))}
    </div>
  )
}

export default InvestorFeatures;
